//noScroll
class LoadingEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const loadingBar = document.querySelector(".loading-bar")

    loadingBar.classList.add("is-active")
    

  }
}
